module.exports = __webpack_public_path__ + "img/arrow.1ffb919e.png";